module.exports = __webpack_public_path__ + "img/location-pin.135ee50f.png";